import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Grid"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 3H4.5C3.67157 3 3 3.67157 3 4.5V9C3 9.82843 3.67157 10.5 4.5 10.5H9C9.82843 10.5 10.5 9.82843 10.5 9V4.5C10.5 3.67157 9.82843 3 9 3ZM9 9H4.5V4.5H9V9ZM19.5 3H15C14.1716 3 13.5 3.67157 13.5 4.5V9C13.5 9.82843 14.1716 10.5 15 10.5H19.5C20.3284 10.5 21 9.82843 21 9V4.5C21 3.67157 20.3284 3 19.5 3ZM19.5 9H15V4.5H19.5V9ZM9 13.5H4.5C3.67157 13.5 3 14.1716 3 15V19.5C3 20.3284 3.67157 21 4.5 21H9C9.82843 21 10.5 20.3284 10.5 19.5V15C10.5 14.1716 9.82843 13.5 9 13.5ZM9 19.5H4.5V15H9V19.5ZM19.5 13.5H15C14.1716 13.5 13.5 14.1716 13.5 15V19.5C13.5 20.3284 14.1716 21 15 21H19.5C20.3284 21 21 20.3284 21 19.5V15C21 14.1716 20.3284 13.5 19.5 13.5ZM19.5 19.5H15V15H19.5V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Grid.vue"]]);
